import axios from "axios";
import React, { useEffect, useState, useCallback } from "react";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  FormGroup,
  Input,
  Row,
  Alert,
  Spinner,
} from "reactstrap";
import AsignaEquiposEdicion from "./AsignaEquiposEdicion";
import Swal from "sweetalert2";

const api = axios.create({
  baseURL: "https://inspecciongnvback-dev.azurewebsites.net/api/v1",
  auth: {
    username: "BasicAuth@icontec.org",
    password: "yQLzqmR7eZSuAmQZUqhY",
  },
});

const EditaEquiposOrden = ({ idOrden, onClose }) => {
  const [data, setData] = useState({ equipoinstalar: [] });
  const [equipos, setEquipos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState("");

  // =============================
  // Cargar datos
  // =============================
  const fetchData = async () => {
    try {
      setLoading(true);

      const [propietariosRes, equiposRes] = await Promise.all([
        api.get(`/ObtenerPropietariosPorVehiculo/${idOrden}`),
        api.get("/ObtenerEquipos"),
      ]);

      if (!propietariosRes.data.length) {
        throw new Error("No se encontraron equipos asociados");
      }

      setData(propietariosRes.data[0]);
      setEquipos(equiposRes.data);
    } catch (err) {
      setError(err.message || "Error cargando datos");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [idOrden]);

  // =============================
  // Manejo cambios inputs
  // =============================
  const handleChange = useCallback(
    (e) => {
      const { name, value, dataset } = e.target;
      const id = Number(dataset.id);

      setData((prev) => ({
        ...prev,
        equipoinstalar: prev.equipoinstalar.map((eq) =>
          eq.id === id
            ? {
                ...eq,
                [name]: name === "equipoId" ? Number(value) : value,
                ...(name === "equipoId" && {
                  nombreEquipo:
                    equipos.find((e) => e.id === Number(value))?.nombre || "",
                }),
              }
            : eq,
        ),
      }));
    },
    [equipos],
  );

  // =============================
  // Actualizar equipos
  // =============================
  const BtnActualizar = async (e) => {
    e.preventDefault();
    setSaving(true);
    setSuccessMessage("");
    setError(null);

    Swal.fire({
      title: "Actualizando...",
      text: "Por favor espera",
      allowOutsideClick: false,
      didOpen: () => Swal.showLoading(),
    });

    try {
      await Promise.all(
        data.equipoinstalar.map((equipo) =>
          api.put(`/ActualizaEquiposInstalar/${equipo.id}`, equipo),
        ),
      );

      Swal.fire({
        icon: "success",
        title: "Actualizado",
        text: "Equipos actualizados correctamente",
        timer: 2500,
        showConfirmButton: false,
      });

      setSuccessMessage("✅ Equipos actualizados correctamente");

      // recargar equipos
      await fetchData();

      // avisar al componente padre
      if (onClose) {
        onClose();
      }
    } catch (err) {
      setError("❌ Error al actualizar los equipos");

      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Ocurrió un error al actualizar los equipos",
      });
    } finally {
      setSaving(false);
    }
  };

  // =============================
  // Render input
  // =============================
  const renderInput = (label, name, value, id, index, type = "text") => (
    <Col lg="6" key={`${name}-${index}`}>
      <FormGroup>
        <label className="form-control-label">{label}</label>
        <Input
          type={type}
          name={name}
          data-id={id}
          value={value || ""}
          onChange={handleChange}
          className="form-control-alternative"
        />
      </FormGroup>
    </Col>
  );

  const formatDateForInput = (date) => {
    if (!date) return "";
    return date.split("T")[0];
  };

  if (loading)
    return (
      <div className="text-center my-4">
        <Spinner color="primary" /> Cargando equipos...
      </div>
    );

  return (
    <form onSubmit={BtnActualizar}>
      <Container fluid>
        <Card className="shadow">
          <CardBody>
            {successMessage && (
              <Alert color="success" className="text-center font-weight-bold">
                {successMessage}
              </Alert>
            )}

            {error && (
              <Alert color="danger" className="text-center">
                {error}
              </Alert>
            )}

            <h3 className="mb-4">Equipos Instalados</h3>

            {data.equipoinstalar.length ? (
              data.equipoinstalar.map((equipo, index) => (
                <Row key={equipo.id}>
                  <Col lg="6">
                    <FormGroup>
                      <label>Nombre Equipo</label>
                      <Input
                        type="select"
                        name="equipoId"
                        data-id={equipo.id}
                        value={equipo.equipoId || ""}
                        onChange={handleChange}
                      >
                        <option value="">Seleccionar...</option>
                        {equipos.map((e) => (
                          <option key={e.id} value={e.id}>
                            {e.nombre}
                          </option>
                        ))}
                      </Input>
                    </FormGroup>
                  </Col>

                  {renderInput(
                    "Serial",
                    "serial",
                    equipo.serial,
                    equipo.id,
                    index,
                  )}
                  {renderInput(
                    "Capacidad",
                    "capacidad",
                    equipo.capacidad,
                    equipo.id,
                    index,
                  )}

                  {renderInput(
                    "Fecha Fabricación",
                    "fechaFabricacion",
                    formatDateForInput(equipo.fechaFabricacion),
                    equipo.id,
                    index,
                    "date",
                  )}

                  {renderInput(
                    "Fecha Próxima Prueba",
                    "prueba",
                    formatDateForInput(equipo.prueba),
                    equipo.id,
                    index,
                    "date",
                  )}

                  {renderInput(
                    "Fecha Última Prueba",
                    "ultimaPrueba",
                    formatDateForInput(equipo.ultimaPrueba),
                    equipo.id,
                    index,
                    "date",
                  )}

                  {renderInput(
                    "Fecha Instalación",
                    "fechaInstalacion",
                    formatDateForInput(equipo.fechaInstalacion),
                    equipo.id,
                    index,
                    "date",
                  )}

                  <Col lg="12">
                    <hr />
                  </Col>
                </Row>
              ))
            ) : (
              <Alert color="warning">No hay equipos instalados</Alert>
            )}

            <Button color="primary" type="submit" disabled={saving}>
              {saving ? <Spinner size="sm" /> : "Actualizar Equipos"}
            </Button>

            {/* CREAR NUEVO EQUIPO */}
            <AsignaEquiposEdicion idOrden={idOrden} onSuccess={fetchData} />
          </CardBody>
        </Card>
      </Container>
    </form>
  );
};

export default EditaEquiposOrden;
